<template>
  <el-dialog
    :visible="isVisible"
    @close="hide"
    :title="title"
    :destroy-on-close="true"
  >
    <loading v-if="!isInitialized"></loading>
    <add-to-group-form v-bind="formData" @stored="onStored"></add-to-group-form>
  </el-dialog>
</template>

<script>
import BaseDialogFormWrapper from "../../dialog-form-wrapper.vue";
import Loading from '../../loading.vue';
import eventBus from '../../../event-bus';
import AddToGroupForm from './form.vue';
import UrlParse from "url-parse";
import QueryString from "qs";
import {addQueryParams} from "../../../libs/url";

export default {
  extends: BaseDialogFormWrapper,

  components: {
    AddToGroupForm,
    Loading,
  },

  computed: {
    /**
     * @return {string}
     */
    title() {
      if (!this.isInitialized) {
        return 'Loading ...';
      }

      return 'Add to group';
    },
  },

  methods: {
    /**
     * @param {string|undefined} message
     */
    onStored({message}) {
      _.isString(message) && this.$message.success(message);
      this.hide();
    },

    /**
     * @param {object|string|null} data
     */
    show(data = null) {
      if (_.isObject(data)) {
        this.formData = data;
      } else {
        this.getFormData(
          _.isString(data) ? addQueryParams(data, this.getQuery()) : this.formDataUrl
        );
      }

      this.isVisible = true;
    },

    /**
     * @return {any|{}}
     */
    getQuery() {
      const url = new UrlParse(window.location.href);

      return QueryString.parse(_.trimStart(url.query, '?'));
    },
  },

  created() {
    eventBus.$on('show-add-to-group-dialog', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-add-to-group-dialog', this.show);
  }
}
</script>

<style scoped>

</style>
